import React, {Component, Fragment} from 'react'
import {Breadcrumb, Button, Card, Popconfirm, Row, Steps, Tooltip} from 'antd'
import KeyTerms from '../../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/Form/KeyTerms'
import WorkingConditions from '../../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/Form/WorkingConditions'
import Compensation from '../../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/Form/Compensation'
import style from '../../../../../../../components/People/Member/Contract/AddContract/style.css'

const Step = Steps.Step

class AddWorkOrders extends Component {
  render() {
    const {
      submitting,
      contract,
      workOrder,
      current,
      type,
      employee,
      submit,
      update,
      updateWorkOrder,
      keyTermsRef,
      workingConditionsRef,
      compensationRef,
      prev,
      next,
      id,
      fetching,
      member,
      contractKey,
      showSkip,
      skip,
    } = this.props
    const titles = {
      new: 'Create new Work Order',
      update: 'Update Work Order',
    }
    const descriptions = {
      new: 'You can add new Employee Work Order by following the steps below.',
      update: 'You need to follow the steps below to update Work Order.',
    }
    const submitButton = {
      new: (
        <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
          <Button loading={submitting} type="primary">
            Submit
          </Button>
        </Popconfirm>
      ),
      update: (
        <Popconfirm title="Sure to Update?" onConfirm={update}>
          <Button loading={submitting} type="primary">
            Update
          </Button>
        </Popconfirm>
      ),
    }
    const steps = [
      {
        title: 'Key Terms',
        content: (
          <KeyTerms
            {...this.props}
            employee={employee}
            ref={keyTermsRef}
            updateWorkOrder={updateWorkOrder}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'keyTerms',
      },
      {
        title: 'Working Conditions',
        content: (
          <WorkingConditions
            {...this.props}
            employee={employee}
            ref={workingConditionsRef}
            updateWorkOrder={updateWorkOrder}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'workingConditions',
      },
      {
        title: 'Compensation',
        content: (
          <Compensation
            {...this.props}
            employee={employee}
            ref={compensationRef}
            updateWorkOrder={updateWorkOrder}
            type={type}
            contract={contract}
            workOrder={workOrder}
          />
        ),
        key: 'compensation',
      },
    ]
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>People</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team">
                Team List
              </Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${id}/#contracts`}>
                {member.fn}
              </Breadcrumb.Item>
              <Breadcrumb.Item
                href={`#/people/member/${id}/contracts/${contractKey}/view#work-orders`}>
                {contract.code}
              </Breadcrumb.Item>
              <Breadcrumb.Item>{workOrder.code}</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>{titles[type]}</h2>
            <p className={style.paragraph}>{descriptions[type]}</p>
          </Row>
        </Card>
        <Card loading={fetching} className={style.contentCard}>
          <Steps current={current}>
            {steps.map(item => (
              <Step key={item.key} title={item.title} />
            ))}
          </Steps>
          <div
            style={{marginTop: '50px', marginBottom: '10px'}}
            className="steps-content">
            {steps[current].content}
          </div>
          <div
            className="steps-action"
            style={{textAlign: 'center', paddingTop: 20}}>
            {current > 0 && (
              <Button style={{marginRight: 8}} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button
                style={{width: '100px'}}
                type="primary"
                onClick={() => next()}>
                Next
              </Button>
            )}
            {current < steps.length - 1 && showSkip && (
              <Tooltip title="Skip validation for now">
                <Button
                  icon="double-right"
                  shape="dashed"
                  onClick={() => skip()}
                />
              </Tooltip>
            )}
            {current === steps.length - 1 &&
              (submitButton[type] || (
                <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
                  <Button loading={submitting} type="primary">
                    Submit
                  </Button>
                </Popconfirm>
              ))}
          </div>
        </Card>
      </Fragment>
    )
  }
}

AddWorkOrders.propTypes = {}
AddWorkOrders.defaultProps = {}

export default AddWorkOrders
